export const SONIOX_WEBSOCKET_URL = 'wss://stt-rt.soniox.com/transcribe-websocket';
export const SONIOX_DICTATION_MODEL = 'stt-rt-v5';
export const SONIOX_AUDIO_FORMAT = 'pcm_s16le';
export const SONIOX_SAMPLE_RATE = 24000;
export const SONIOX_NUM_CHANNELS = 1;
export const SONIOX_MAX_ENDPOINT_DELAY_MS = 700;
export const SONIOX_TURN_DETECTION_THRESHOLD = 0.7;
export const SONIOX_SPECIAL_TOKENS = new Set(['<end>', '<fin>']);
//# sourceMappingURL=consts.js.map